import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import client from "../../../../apollo";
import {
	NextSalesCharterStatusesDocument,
	NextSalesCharterStatusesQuery,
} from "__generated__/view/charters/graphql/charter.queries.generated";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { SalesCharterStatus } from "__generated__/enums";

export type SalesCharterStatusSelectOption = ChildPropsFromArray<NextSalesCharterStatusesQuery, "nextSalesCharterStatuses">;

const SalesCharterStatusSelect = <Multiple extends boolean = false,>({
	currentStatus,
	...rest
}: Omit<SelectProps<SalesCharterStatusSelectOption, Multiple>, "fetchOptions" | "paginated"> & {
	currentStatus?: SalesCharterStatus | null;
}) => {

	const onFetchOptions = async () => {
		try  {
			const result = await client.query({
				query: NextSalesCharterStatusesDocument,
				variables: {
					currentStatus: currentStatus,
				},
			});

			return result.data.nextSalesCharterStatuses;
		} catch (response) {
			return [];
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `${option.languageKeyPrefix}${option.name}` })}
			getOptionColor={option => option.color}
			disableSearch
			{...rest}
		/>
	);
};

export default SalesCharterStatusSelect;
